const MEMORY_KEY = 'luna_user_context';

interface LunaMemory {
  visitCount: number;
  lastVisit: string;
  lastTopic: string | null;
}

const defaultMemory = (): LunaMemory => ({
  visitCount: 0,
  lastVisit: new Date().toISOString(),
  lastTopic: null,
});

export const MemoryManager = {
  getMemory(): LunaMemory {
    try {
      const raw = localStorage.getItem(MEMORY_KEY);
      if (!raw) return defaultMemory();
      return JSON.parse(raw) as LunaMemory;
    } catch {
      return defaultMemory();
    }
  },

  recordVisit(): LunaMemory {
    const mem = this.getMemory();
    const updated: LunaMemory = {
      ...mem,
      visitCount: mem.visitCount + 1,
      lastVisit: new Date().toISOString(),
    };
    try {
      localStorage.setItem(MEMORY_KEY, JSON.stringify(updated));
    } catch { /* storage unavailable */ }
    return updated;
  },

  updateTopic(topic: string): void {
    const mem = this.getMemory();
    const updated: LunaMemory = { ...mem, lastTopic: topic };
    try {
      localStorage.setItem(MEMORY_KEY, JSON.stringify(updated));
    } catch { /* storage unavailable */ }
  },

  buildMemoryPrompt(): string {
    const mem = this.getMemory();
    if (mem.visitCount > 1 && mem.lastTopic) {
      return `\n\nCRITICAL MEMORY: This is a returning user (Visit #${mem.visitCount}). Last time, they were interested in '${mem.lastTopic}'. When they greet you or wake you up, briefly say 'Welcome back!' and naturally mention or ask if they are still interested in '${mem.lastTopic}' before moving on. Keep this memory reference warm and conversational — like an old friend picking up where you left off.`;
    }
    if (mem.visitCount > 1) {
      return `\n\nCRITICAL MEMORY: This is a returning user (Visit #${mem.visitCount}). Greet them with a warm 'Welcome back!' when they first speak.`;
    }
    return '';
  },
};
